import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Revendedor } from 'src/app/model/Revendedor';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RevendedorService {

  constructor(private http: HttpClient) { }

  findAll(): Observable<Revendedor[]> {
    return this.http.get<Revendedor[]>(`${environment.apiUrl}/view/revendedor`);
  }

  findById(id: number) {
    return this.http.get(`${environment.apiUrl}/view/revendedor/${id}`);
  }

  findByIdExample(id: number) { }

  save(revendedor: Revendedor) {
    return this.http.post(`${environment.apiUrl}/view/revendedor`, revendedor);
  }

  saveCytomic(revendedor: Revendedor) {
    return this.http.post(`${environment.apiUrl}/view/revendedor-cytomic`, revendedor);
  }

  delete(id: number) {
    return this.http.delete(`${environment.apiUrl}/view/revendedor/${id}`);
  }
}
